import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(
      private httpClient: HttpClient
  ) { }

  public sendEmail(data: any) {
    return this.httpClient.post('https://tourdearmenia.com/assets/mail.php', data);
  }

}
